export const createToken = () => 'Logovanje/NapraviToken';
export const refreshToken = () => 'Logovanje/OsveziCookieToken'; // Vladan Radovanovic 2025.10.02 OsveziCookieToken requies token in Cookie, while Logovanje/OsveziToken requires token in request body
export const oneTimePassword = () => 'FNOL/GenerisiPrivremenuLozinku';
